module.exports = __webpack_public_path__ + "static/media/icon-auth-flow-3.8705f369.png";